/* eslint-disable @typescript-eslint/no-floating-promises */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unnecessary-condition */
/* eslint-disable no-else-return */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/prefer-promise-reject-errors */
import Swal from "sweetalert2";
import { API_URL } from "utils/constant";
import http from "./http-client";
import type { AxiosRequestConfig } from "axios";

async function client(
  endpoint: string,
  {
    data,
    headers: customHeaders,
    ...customConfig
  }: AxiosRequestConfig & {
    data?: any;
    successMessage?: string;
    errorMessage?: string;
  } = {}
) {
  const config = { ...customConfig };
  const onSuccess = async (response: any) => {
    // 1. Extract the header value safely as a string or undefined
    const licenseWarning = response.headers["x-license-warning"] as
      | string
      | undefined;

    if (!licenseWarning) {
      if (process.env.REACT_APP_CLIENT !== "CT") {
        sessionStorage.clear();
      }
      window.top?.postMessage(
        { type: "logout" },
        process.env.REACT_APP_ADMIN as string
      );
      return Promise.reject({ message: "Please re-authenticate." });
    } else if (licenseWarning === "Valid") {
      // 2. Specify the event detail type structure explicitly
      const event = new CustomEvent<{ message: string }>("licenseWarning", {
        detail: { message: "" }
      });
      window.dispatchEvent(event);
    } else {
      const event = new CustomEvent<{ message: string }>("licenseWarning", {
        detail: { message: licenseWarning }
      });
      window.dispatchEvent(event);
    }
    if (response.status === 200) {
      if (response?.data?.failedRequests?.length) {
        Swal.fire({
          icon: "success",
          title: `<span style="font-size:1.5rem">Request Successful.</span>`,
          html: `<ul style="text-align: left; list-style:auto; padding: 0 0 0 1.6em">${response?.data?.failedRequests?.map((i: any) => `<li>${i}</li>`)}</ul>`
        });
      } else if (
        customConfig?.successMessage &&
        Boolean(response?.data) &&
        typeof response?.data === "string"
      ) {
        Swal.fire({
          icon: "success",
          title: `<span style="font-size:1.5rem">${customConfig?.successMessage}</span>`,
          html: `<ul style="text-align: left; list-style:auto; padding: 0 0 0 1.6em"><li>${response?.data?.replaceAll(",", "</li><li>")}</li></ul>`
        });
      } else if (
        customConfig?.errorMessage &&
        Boolean(response?.data) &&
        typeof response?.data === "string"
      ) {
        Swal.fire({
          icon: "success",
          title: `<span style="font-size:1.5rem">${customConfig?.errorMessage}</span>`,
          html: `<ul style="text-align: left; list-style:auto; padding: 0 0 0 1.6em"><li>${response?.data?.replaceAll(",", "</li><li>")}</li></ul>`
        });
      } else if (customConfig?.successMessage) {
        Swal.fire({
          icon: "success",
          title: "Success",
          text: customConfig?.successMessage
        });
      }
      return response?.data;
    } else {
      return Promise.reject({ message: data?.message || response?.title });
    }
  };

  const onFail = (error: any) => {
    if (error.status === 409) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "The resource you are trying to add already exists."
      });
      return Promise.reject({
        message: error?.message || error?.title,
        status: error.status
      });
    }

    if (error.status === 403) {
      Swal.fire({
        icon: "error",
        title: `Error ${error.status}`,
        text: "You are not authorized to access this resource. kindly contact support."
      });
      return Promise.reject({
        message: error?.message || error?.title,
        status: error.status
      });
    }

    if (error.status === 404 || error.status === 401) {
      return Promise.reject({
        message: data?.message || error?.message || error?.title,
        status: error.status
      });
    }
    if (error?.code === "ERR_CANCELED") {
      return Promise.reject({
        message: error?.message,
        status: error?.code
      });
    }

    if (error.status === 500) {
      Swal.fire({
        icon: "error",
        title: `Error ${error.status}`,
        text: "Internal Server Error. Please try again later or contact customer support."
      });
      return Promise.reject({
        message: error?.message || error?.title,
        status: error.status
      });
    }

    if (error.status === 400) {
      if (error?.response?.data && typeof error?.response?.data === "string") {
        Swal.fire({
          icon: "warning",
          title: `<span style="font-size:1.5rem">Following request(s) failed.</span>`,
          html: `<ul style="text-align: left; list-style:auto; padding: 0 0 0 1.6em"><li>${error?.response?.data?.replaceAll(",", "</li><li>")}</li></ul>`
        });
      } else {
        Swal.fire({
          icon: "error",
          title: `Error ${error.status}`,
          text: "Something went wrong. Please contact customer support."
        });
      }

      return Promise.reject({
        message: error?.message || error?.title,
        status: error.status
      });
    } else {
      Swal.fire({
        icon: "error",
        title: `Error ${error.status}`,
        text: "Something went wrong please try again."
      });
      return Promise.reject({
        message: error?.message || error?.title,
        status: error.status
      });
    }
  };

  if (customConfig.method === "delete") {
    return http
      .delete(`${API_URL}/${endpoint}`, { data, ...config })
      .then(onSuccess)
      .catch(onFail);
  } else if (data && customConfig.method === "GET") {
    return http
      .get(`${API_URL}/${endpoint}`, { data, ...config })
      .then(onSuccess)
      .catch(onFail);
  } else if (data) {
    return http
      .post(`${API_URL}/${endpoint}`, data, config)
      .then(onSuccess)
      .catch(onFail);
  } else {
    return http
      .get(`${API_URL}/${endpoint}`, config || {})
      .then(onSuccess)
      .catch(onFail);
  }
}

export { client };
